import React from 'react';
import { Attach16Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { StatusPill } from '../../../theme/components/StatusPill';
import { useServiceReceiptsStyles } from './ServiceReceipts.Styles';

export interface ServiceReceiptCountPillProps {
  count: number;
}

/** Receipts of a service: pill with a paperclip and the number ("—" when there is none). */
export const ServiceReceiptCountPill = ({ count }: ServiceReceiptCountPillProps) => {
  const { t } = useTranslation();
  const styles = useServiceReceiptsStyles();
  if (count <= 0) {
    return (
      <span
        className={styles.emptyCount}
        aria-label={t('serviceReceipts.noReceipts')}
        title={t('serviceReceipts.noReceipts')}
        data-testid="service-receipt-count-empty"
      >
        —
      </span>
    );
  }
  const label = t('serviceReceipts.countLabel', { count });
  return (
    <StatusPill
      tone="info"
      icon={<Attach16Regular />}
      className={styles.countPill}
      aria-label={label}
      title={label}
      data-testid="service-receipt-count"
    >
      {count}
    </StatusPill>
  );
};

export default ServiceReceiptCountPill;
